import { REGEX_COMPLETION_MARK_FULL } from '@/domain/models/taskLine/taskLineHelpers';

const DEFAULT_COMPLETION_MARK = '✔';

/**
 * Removes a leading completion mark token from a task definition.
 *
 * @param {string} definition
 * @returns {string}
 */
export const removeCompletionMark = (definition) => {
  const value = String(definition || '').trim();
  return value.replace(REGEX_COMPLETION_MARK_FULL, '').trim();
};

/**
 * Ensures a task definition has a completion mark token at the beginning.
 *
 * @param {string} definition
 * @param {string} mark
 * @returns {string}
 */
export const addCompletionMark = (
  definition,
  mark = DEFAULT_COMPLETION_MARK
) => {
  const base = removeCompletionMark(definition);
  return `${mark} ${base}`.trim();
};

/**
 * Applies completion state to a task definition.
 *
 * @param {string} definition
 * @param {boolean} completed
 * @returns {string}
 */
export const setCompletionState = (definition, completed) =>
  completed ? addCompletionMark(definition) : removeCompletionMark(definition);
